// import anime from 'animejs/lib/anime.es';
// import { runInThisContext } from 'vm';

export default class SelectRedirect {

  constructor(debug = false) {

    this.debug = debug;

    if (this.debug) console.log('SelectRedirect init');

    if (this.setVars()) {
      if (this.debug) console.log('SelectRedirect vars init done');
      this.setEvents();
    }
  }

  setVars()
  {
    this.selectRedirectArr = document.querySelectorAll('.jsSelectRedirect');
    if (!this.selectRedirectArr.length) return false;

    return true;
  }

  setEvents()
  {
    this.selectRedirectArr.forEach((el) => {
      el.addEventListener('change', (e) => {
        e.preventDefault();
        this.onClick(e.target);
      });
    });
  }

   
  onClick(el)
  {
    if (typeof el.value !== 'undefined' && el.value) window.location = el.value;
  }
}
